import React, { useEffect, useState, useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import BasicModal from "../../../core/BaseComponents/Modal";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { callAPI } from "../../../../axios";
import { Tooltip } from "@mui/material";

function CarouselComponent(props) {
  const sliderRef = useRef(null);
  const [reOrderImages, setReOrderImages] = useState([]);
  const [sequenceOrder, setSequenceOrder] = useState([]);
  const [reOrderDisabled, setReOrderDisabled] = useState('');

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: props?.initialSlide
  };

  function handleOnDragEnd(result) {
    if (!result.destination) return;

    const [reorderedItem] = sequenceOrder.splice(result.source.index, 1);
    sequenceOrder.splice(result.destination.index, 0, reorderedItem);
    callAPI(`/scheduled-screen-saver/images/reorder?id=${props?.listConfigId}`, "PUT", sequenceOrder)
      .then(function (response) {
        // console.log(response);
        reOrderList();
      })
      .catch(function (error) {
        console.warn(error.response?.data?.errorMessage);
      });
  }

  const reOrderList = () => {
    callAPI(`/scheduled-screen-saver/${props?.listConfigId}`, "GET")
      .then((res) => {
        setReOrderDisabled(res?.isPublished)
        setReOrderImages(res?.imageResponse);
        setSequenceOrder(res?.imageResponse?.map((item) => item?.id))
      })
      .catch((err) => {
        console.warn(err.message);
      });
  }

  useEffect(() => {
    reOrderList();
  }, [props]);

  const handleDelete = (url, id) => {
    props?.handleDeleteBannerAPI(url, id)
  }

  const handleIntialSlideImage = (index)=>{
    if (sliderRef.current) {
      sliderRef.current.slickGoTo(index);
    }
  }

  return (
    <BasicModal
      popupOpen={props?.showPreviewPopUp}
      popupCloseHandler={() => { props.setShowPreviewPopUp(false); props?.BannerListApi() }}
      isCross={true}
      heading={<p className="mb-2">Screensaver Images Preview</p>}
      popupSize='col-10'
      bodyMessage={
        <>
          {
            reOrderImages?.length > 1 ? <>
              <Slider {...settings} ref={sliderRef} className="preview-slider-image mx-4">
                {reOrderImages?.map((bannerImagesList) =>
                  <>
                    <img src={bannerImagesList?.url} alt={bannerImagesList?.id} />
                    <p className={props?.textPostionClass(bannerImagesList?.textPosition)}>{bannerImagesList?.text}</p>
                  </>
                )}
              </Slider>
            </> : <div className="preview-banner-img screen-single-image">
              <>
                <img src={reOrderImages[0]?.url} alt={reOrderImages[0]?.id} width={100} />
                <p className={props?.textPostionClass(reOrderImages[0]?.textPosition)}>{reOrderImages[0]?.text}</p>
              </>
            </div>
          }
          {reOrderImages.length > 1 &&
            <div className="mt-5">
              <h6 className="text-start mb-3">Re-Order / Delete Screensaver Images</h6>
              {
                reOrderDisabled || props.editBannerSid.id === props.listConfigId ? <div className="delete-config-images justify-content-center">
                  {reOrderImages?.map((url) => <div><Tooltip placement="top" title={`${reOrderDisabled ? 'Un-Publish to re-order Screensaver' : 'Cancel edit mode to perform actions'}`}>
                    <img
                    src={url?.url}
                    alt={url?.id}
                    className="undrag-images"
                  />
                    <Tooltip title={`${reOrderImages?.length === 1 ? 'At least one image required in hero banner' : reOrderDisabled ? "Un-Publish to perform actions" : props?.editBannerSid.id === props?.listConfigId ? "Cancel edit mode to perform actions" : 'Delete'}`}>
                      <span className={`${reOrderImages?.length === 1 || reOrderDisabled || props?.editBannerSid.id === props?.listConfigId ? 'cross-mark-disabled' : 'cross-mark-enabled'}`} onClick={() => reOrderImages?.length === 1 || reOrderDisabled || props?.editBannerSid.id === props?.listConfigId ? "" : ""}>X</span>
                    </Tooltip>
                  </Tooltip></div>)}
                </div> : <DragDropContext onDragEnd={handleOnDragEnd} >
                  <Droppable droppableId="droppable" direction="horizontal">
                    {(provided) => (
                      <div
                        className="delete-config-images justify-content-center"
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                      >
                        {reOrderImages?.map((url, index) => (
                          <Draggable key={String(url?.id)} draggableId={String(url?.id)} index={index}>
                            {(provided) => (
                              <div
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                              >
                                <img
                                  src={url?.url}
                                  alt={url?.id}
                                  className="drag-images"
                                  onClick={()=> handleIntialSlideImage(index)}
                                />
                                <Tooltip title={`${reOrderImages?.length === 1 ? 'At least one image required in hero banner' : reOrderDisabled ? "Un-Publish to perform actions" : props?.editBannerSid.id === props?.listConfigId ? "Cancel edit mode to perform actions" : 'Delete'}`}>
                                  <span className={`${reOrderImages?.length === 1 || reOrderDisabled || props?.editBannerSid.id === props?.listConfigId ? 'cross-mark-disabled' : 'cross-mark-enabled'}`} onClick={() => reOrderImages?.length === 1 || reOrderDisabled || props?.editBannerSid.id === props?.listConfigId ? "" : handleDelete(url, props?.listConfigId)}>X</span>
                                </Tooltip>
                              </div>
                            )}
                          </Draggable>
                        ))}
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
              }
            </div>
          }
        </>
      }
    />
  );
}

export default CarouselComponent;
